module.exports = __webpack_public_path__ + "static/media/mic-off.9622053a.svg";